import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, FormSelect } from "../../components";
import {
  fetchProjects,
  fetchStudyCases,
  linkResourceToProject,
} from "../../api";
import { back, replace } from "../../actions/nav-actions";
import { notify } from "../../utils";

class Form extends Component {
  constructor(props) {
    super(props);
    const params = props.match.params || {};
    this.state = {
      key: params.key,
      results: [],
      project: undefined,
      modal_visible: true,
    };
    this.getData = this.getData.bind(this);
    this.onRequest = this.onRequest.bind(this);
  }
  componentDidMount() {
    this.getData();
  }
  getData() {
    if (!this.state.key) return;
    fetchProjects(this.props.user.token)
      .then(({ projects }) => {
        if (!this.props.user.is_admin) return projects;
        return fetchStudyCases(this.props.user.token).then(({ studycases }) => {
          return [...projects, ...studycases];
        });
      })
      .then((results) => {
        this.setState({ results });
      })
      .catch((err) => {
        alert(err.message);
      });
  }
  componentWillReceiveProps(newProps) {
    const params = newProps.match.params || {};
    if (params.key !== this.state.key) {
      this.setState({ key: params.key, modal_visible: true }, this.getData);
    }
  }
  onRequest() {
    // send
    if (!this.state.project) return;
    const params = this.props.match.params || {};
    linkResourceToProject(this.props.user.token, params.key, {
      project: this.state.project,
    })
      .then((link) => {
        notify(
          "Resource Linked!",
          this.props.user.is_admin
            ? "Go to Project/Study Case to See"
            : "Go to Project to see"
        );
      })
      .catch((err) => {
        notify("Error to link", err.message, "error");
      });
  }
  getNames = () => {
    return this.state.results.map((project) => {
      if (project.is_study_case) {
        return { label: `(Study Case) ${project.name}`, value: project.code };
      }
      return { label: project.name, value: project.code };
    });
  };
  render() {
    return (
      <Modal
        visible={this.state.modal_visible}
        onClose={() => this.setState({ modal_visible: false }, this.props.back)}
        title={
          this.props.user.is_admin
            ? "Add to Project/Study Case"
            : "Add to Project"
        }
        action_text="ADD RESOURCE"
        onActionClick={this.onRequest}
      >
        <FormSelect
          onChange={(option) => {
            let { project } = this.state;
            if (option) project = option.value;
            else project = undefined;
            this.setState({ project });
          }}
          placeholder={
            this.props.user.is_admin ? "Projects/Study Cases" : "Projects"
          }
          searchable
          required
          value={this.state.project}
          options={this.getNames()}
        />
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.authReducer.user });

const mapDispatchToProps = (dispatch) => ({
  back() {
    dispatch(back());
  },
  replace(routeName) {
    dispatch(replace(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);



// WEBPACK FOOTER //
// ./src/routers/Library/AddToProjectForm.js